import { render, staticRenderFns } from "./MrCategories.vue?vue&type=template&id=6a72fb7c&"
import script from "./MrCategories.vue?vue&type=script&lang=js&"
export * from "./MrCategories.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports